<nb-card style="width: 30rem">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <h6>Account Details</h6>
    <nb-icon
      icon="close-outline"
      pack="fci"
      class="cursor-pointer"
      (click)="ref?.close()"
    ></nb-icon>
  </nb-card-header>
  <nb-card-body class="pl-4">
    <div>
      <nb-icon
        class="wide-icon-class"
        pack="fci"
        [icon]="accountIconMap[data?.provider]"
      ></nb-icon>
      <span class="weight-600 ml-3">{{ data?.name || '--' }}</span>
    </div>
    <div *ngIf="data?.accountType === 'VERSION_CONTROL'">
      <div *ngIf="data?.associatedTo?.length > 0" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Project</p>
        <label>
          <span
            class="primary-text weight-600 cursor-pointer"
            *ngFor="
              let stack of data?.associatedTo;
              let i = index;
              let last = last
            "
            (click)="goToStack(stack, ref)"
          >
            {{ !last ? stack?.stackName + ',' : stack?.stackName }}
          </span>
        </label>
      </div>
      <div class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Username</p>
        <label>{{ data?.userName || '--' }}</label>
      </div>
      <div
        *ngIf="data?.provider === 'GITHUB' || data?.provider === 'GITLAB'"
        class="col-12 p-0 mt-4"
      >
        <p class="paragraph-3 mb-2 weight-600">Personal access token</p>
        <label class="text-break">{{ data?.accessToken || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'BITBUCKET'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Password</p>
        <label>{{ data?.accessToken || '--' }}</label>
      </div>
    </div>
    <div *ngIf="data?.accountType === 'CLOUD'">
      <div *ngIf="data?.envs?.length > 0" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Environments</p>
        <label>
          <span
            (click)="goToEnv(env, ref)"
            class="primary-text weight-600 cursor-pointer"
            *ngFor="let env of data?.envs; let i = index; let last = last"
          >
            {{ !last ? env.name + ',' : env.name }}
          </span>
        </label>
      </div>
      <div *ngIf="data?.provider === 'AWS'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">External ID</p>
        <label>{{ data?.externalId || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'AWS'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">IAM role</p>
        <label>{{ data?.iamRole || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'AZURE'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Subscription ID</p>
        <label>{{ data?.subscriptionId || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'AZURE'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Tenant ID</p>
        <label>{{ data?.tenantId || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'AZURE'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Client ID</p>
        <label>{{ data?.clientId || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'AZURE'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Client Secret</p>
        <label>{{ data?.clientSecret || '--' }}</label>
      </div>
      <div *ngIf="data?.provider === 'GCP'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Service account key</p>
        <textarea
          name="serviceKey"
          fullWidth
          nbInput
          id="serviceKey"
          autocomplete="off"
          style="font-weight: 400"
          readonly
          >{{ data?.serviceAccountKey || '--' }}</textarea
        >
      </div>
      <div *ngIf="data?.provider === 'GCP'" class="col-12 p-0 mt-4">
        <p class="paragraph-3 mb-2 weight-600">Project ID</p>
        <label>{{ data?.project || '--' }}</label>
      </div>
      <div
        *ngIf="data?.accountType === 'CLOUD' && data?.provider === 'KUBERNETES'"
        class="col-12 p-0 mt-4"
      >
        <p class="paragraph-3 mb-2 weight-600">Host</p>
        <label>{{ data?.host || '--' }}</label>
      </div>
    </div>
  </nb-card-body>
</nb-card>
